import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';

import { App } from './app/App.js';
import './styles/tokens.css';
import './styles/global.css';
import './styles/shell.css';

const root = document.getElementById('root');
if (!root) throw new Error('Admin root element is missing');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
